import React from 'react';
import { connect } from 'react-redux';
import {
  generatePath, Redirect, RouteComponentProps, withRouter,
} from 'react-router-dom';

import { isFinishedFetching, ResourcesList } from 'redux-and-the-rest';
import LoadingIndicator from '../shared/LoadingIndicator';
import { ApplicationState } from '../../redux/types';
import { getOrFetchGameScores } from '../../redux/reducers/gameScore';
import { GameScoreModel } from '../../models/gameScoreModel';
import { Routes } from '../../routes';

import './Island.scss';

interface Props {
  gameScores: ResourcesList<GameScoreModel>;
  islandId: string,
}

/**
 * Get the game scores, determine if there any
 * If so, redirect to the first game scores
 * Otherwise, a message to indicate no scores.
 */
const Island = ({ gameScores, islandId }: Props): React.ReactElement => {
  if (!isFinishedFetching(gameScores)) {
    return <LoadingIndicator />;
  }

  if (!gameScores.items.length) {
    return (
      <div className="no-scores">
        Play the games to generate scores!
      </div>
    );
  }

  // Find the game Ids from the game scores
  const gameIds: string[] = gameScores.items.map((gameScore) => gameScore.values.game.id);
  const uniqueGameIds = [...new Set(gameIds)];

  const gameScorePath = generatePath(Routes.Account.Student.GameScore, {
    id: islandId,
    gameId: uniqueGameIds[0],
  });

  return <Redirect to={gameScorePath} />;
};

const mapStateToProps = (
  { gameScores }: ApplicationState,
  { match: { params: { id } } }: RouteComponentProps<{ id: string; }>,
) => ({
  gameScores: getOrFetchGameScores(gameScores, { islandId: id, include: 'game' }),
  islandId: id,
});

export default withRouter(connect(mapStateToProps)(Island));
